import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  UseModalProps,
} from "@chakra-ui/modal";
import { ModalBody, ThemingProps } from "@chakra-ui/react";
import React, { useCallback, useRef } from "react";
import { UserFilterQueryForm } from "../../forms/UserFilterQueryForm";
import { useAdminApiClient } from "../../hooks/useApiClient";
import { useToast } from "../../hooks/useToast";

interface UserFilterQueryModalProps {
  isOpen: boolean;
  userQueryFilter?: UserFilterType;
  onSuccess: (query?: UserFilterType) => void;
  onClose: () => void;
}

export type UserFilterType = {
  uid?: string;
  businessId?: string;
  emailAddressContains?: string;
  phoneNumberContains?: string;
  displayNameContains?: string;
  customClaimKeys?: string;
  customClaimValueContains?: string;
  includeServiceAccount?: boolean | undefined;
  isDisabledEquals?: boolean | undefined;
};

export const UserFilterQueryModal = ({
  isOpen,
  userQueryFilter,
  onSuccess,
  onClose,
  ...modalProps
}: UserFilterQueryModalProps & UseModalProps & ThemingProps<"Modal">) => {
  const initialFocusRef = useRef<HTMLInputElement>(null);
  const { showErrorToast } = useToast();
  const apiClient = useAdminApiClient();

  const onFailure = useCallback(() => {
    showErrorToast("Failed to create user filter query.");
  }, [showErrorToast]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      initialFocusRef={initialFocusRef}
      {...modalProps}
    >
      <ModalOverlay></ModalOverlay>
      <ModalContent>
        <ModalContent>
          <ModalHeader>User Filter Query</ModalHeader>
          <ModalBody>
            <UserFilterQueryForm
              apiClient={apiClient}
              query={userQueryFilter}
              onSuccess={onSuccess}
              onCancel={onClose}
            />
          </ModalBody>
        </ModalContent>
      </ModalContent>
    </Modal>
  );
};
